import DownArrow from "@vds/icons/down-arrow";
import Filter from "@vds/icons/filter";
import { getSortingIcon, getFilterIcon } from "../global/utility/tableUtils";
import { Link } from "react-router-dom";
import { Title, Body } from "@vds/typography";
import { TextLink } from "@vds/buttons";
import { Icon } from "@vds/icons";
import { Badge } from "@vds/badges";
import { getFilterOptions } from "../global/utility/deviceTableUtils";
import { isWithin24Hour } from "../utils";
import { TABLE_UI_TEXT } from "../global/constants/tableConstants";
import {
  SiteNameCell,
  SiteNameText,
  TruncatedSpan,
} from "../styles/sitesModule.styles";

export const getSitesTableColumns = ({
  showTableFilter,
  filteredInfo,
  siteList = [],
  createSorterForAlertStatus,
  createTableFilterList,
  createTableFilterStaticList,
  GmtToLocal,
  navigate,
  handleDelete,
  handleSiteClick
}) => {
  //sort children - sitename in alphabetical order
  siteList.forEach((site) => {
    if (site.children) {
      const sortedChildren = site.children.sort((a, b) =>
        String(a.sitename).localeCompare(String(b.sitename))
      );
      site.children = sortedChildren;
    }
  });
  //show "new" keyword based on latest time stamp for campus/sites
  siteList.sort((a, b) => {
    const dateA = new Date(a.createdon);
    const dateB = new Date(b.createdon);
    return dateB - dateA;
  });
  const buildingsSet = new Set(siteList.map((record) => record.buildings));
  const buildingFilters = [...buildingsSet].map((building) => ({
    text: building?.toString(),
    value: building,
  }));

  const filterStates = siteList.filter((obj, index) => {
    return index === siteList.findIndex((o) => obj.states === o.states);
  });

  const filterBuildings = siteList.filter((obj, index) => {
    return (
      obj.buildings !== undefined &&
      index === siteList.findIndex((o) => obj.buildings === o.buildings)
    );
  });

  return [
    {
      title: "",
      dataIndex: "expandCol",
      key: "expandCol",
      width: 48,
    },
    {
      title: (
        <Title size="small" bold primitive="h2" viewport="desktop">
          Site Name
        </Title>
      ),
      dataIndex: "sitename",
      width: "40%",
      key: "sitename",
      sortDirections: ["ascend", "descend", "ascend"],
      sorter: (a, b) =>
        a?.sitename?.toLowerCase() < b?.sitename?.toLowerCase() ? -1 : 1,
      sortIcon: ({ sortOrder }) => getSortingIcon(sortOrder),
      ellipsis: true,
      isLink: true,
      navLinks: "/editsite",
      onCell: () => ({
        style: {
          maxWidth: 0,
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap"
        }
      }),
      render: (text, record) => {
        const linkUrl = record.isCampus ? `/campusDetails?siteId=${encodeURIComponent(record.campusId)}` : "/editsite";
        return (
          <SiteNameCell title={text}>
            {isWithin24Hour(record?.createdon) && (
              <Badge fillColor="black">{TABLE_UI_TEXT.NEW_BADGE_LABEL}</Badge>
            )}
            <SiteNameText>
              <TextLink
                type="standAlone"
                onClick={() => (handleSiteClick ? handleSiteClick(linkUrl, record) : navigate(linkUrl, { state: { record, mode: "edit" } }))}
                size="large"
                style={{ marginLeft: "10px" }}
              >
                <TruncatedSpan>{text}</TruncatedSpan>
              </TextLink>
            </SiteNameText>
          </SiteNameCell>
        );
      }
      // filteredValue: filteredInfo.sitename || null,
      // showCheckBox: false,
      // customStyle: { width: "100%" },
      // onFilter: (value, record) => record?.sitename?.includes(value),
      // filterMode: "tree",
      // filterSearch: true,
    },
    // {
    //   title: (
    //     <Title size="small" bold primitive="h2" viewport="desktop">
    //       City
    //     </Title>
    //   ),
    //   dataIndex: "city",
    //   width: "20%",
    //   key: "city",
    //   sorter: (a, b) =>
    //     a?.city?.toLowerCase() < b?.city?.toLowerCase() ? -1 : 1,
    //   sortDirections: ["ascend", "descend", "ascend"],
    //   sortIcon: ({ sortOrder }) => getSortingIcon(sortOrder),
    //   // filters: showTableFilter
    //   //   ? createTableFilterList(siteList, "city")
    //   //   : false,
    //   // filterIcon: (filtered) => getFilterIcon(filtered),
    //   // filterMode: "tree",
    //   // filteredValue: filteredInfo?.city || null,
    //   // showMultiColorSeverity: true,
    //   // customStyle: { width: "100%" },
    //   // onFilter: (value, record) => record?.city === value,
    // },
    {
      title: (
        <Title size="small" bold primitive="h2" viewport="desktop">
          State
        </Title>
      ),
      dataIndex: "states",
      width: "30%",
      key: "states",
      isFilter: true,
      filter: getFilterOptions(filterStates, "states"),
      sortIcon: ({ sortOrder }) => getSortingIcon(sortOrder),
      filterMode: "tree",
      filteredValue: filteredInfo?.states || null,
      customStyle: { width: "100%" },
      sorter: (a, b) =>
        a?.states?.toLowerCase() < b?.states?.toLowerCase() ? -1 : 1,
      sortDirections: ["ascend", "descend", "ascend"],
      // filters: showTableFilter
      //   ? createTableFilterList(siteList, "states")
      //   : false,
      // filterIcon: (filtered) => getFilterIcon(filtered),
      // showMultiColorSeverity: true,
      // onFilter: (value, record) => record?.states?.includes(value),
    },
    {
      title: (
        <Title size="small" bold primitive="h2" viewport="desktop">
          Buildings
        </Title>
      ),
      dataIndex: "buildings",
      key: "buildings",
      width: "30%",
      isFilter: true,
      filter: getFilterOptions(filterBuildings, "buildings"),
      sortIcon: ({ sortOrder }) => getSortingIcon(sortOrder),
      filteredValue: filteredInfo?.buildings || null,
      onFilter: (value, record) => record?.buildings === value,
      sorter: (a, b) => a?.buildings - b?.buildings,
      sortDirections: ["ascend", "descend", "ascend"],
      // filterIcon: (filtered) => getFilterIcon(filtered),
      // filters: buildingFilters,
      // filterMode: "tree",
    },
    // {
    //   title: (
    //     <Title size="small" bold primitive="h2" viewport="desktop">
    //       Actions
    //     </Title>
    //   ),
    //   width: "20%",
    //   dataIndex: "actions",
    //   display: "flex",
    //   flexDirection: "row",
    //   editColumn: true,
    //   hasNoText: true,
    //   customStyle: { minWidth: "60px" },
    //   render: (text, record) => {
    //     return (
    //       <div style={{ display: "flex", gap: "10px" }}>
    //         <div
    //           style={{ cursor: "pointer" }}
    //           onClick={() => handleDelete(record.key)}
    //         >
    //           <Icon name="trash" size="medium" color="#000000" />
    //         </div>
    //       </div>
    //     );
    //   },
    // },
  ];
};
